/**
 * MODULE: domain/pages/frontend/components/editor/PagesImageBlockView.tsx
 */

import { NodeViewWrapper } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';

export function PagesImageBlockView({ node, selected }: NodeViewProps) {
  const url = String(node.attrs.url ?? '');
  const filename = String(node.attrs.filename ?? 'Image');

  return (
    <NodeViewWrapper
      className={`my-4 ${selected ? 'ring-2 ring-blue-400 ring-offset-2 dark:ring-offset-gray-950' : ''}`}
      data-testid="pages-image-block"
    >
      {url ? (
        <img
          src={url}
          alt={filename}
          className="max-h-96 w-full rounded-lg border border-gray-200 object-contain dark:border-gray-700"
        />
      ) : (
        <div className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-sm text-gray-500 dark:border-gray-600">
          Image unavailable
        </div>
      )}
      <p className="mt-1 truncate text-xs text-gray-500 dark:text-gray-400">{filename}</p>
    </NodeViewWrapper>
  );
}
